import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=a181b89e&scoped=true&"
import script from "./FolderItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./FolderItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a181b89e",
  null
  
)

export default component.exports